import captainAppVersion from "./captainAppVersion.component";
import captainAppVersionUrls from "./captainAppVersion.urls";
import CaptainAppVersionTransforms from "./captainAppVersion.transforms";

const captainAppVersionModule = angular
  .module("app.components.captainAppVersion", [])
  .component("captainAppVersionPage", captainAppVersion)
  .service("CaptainAppVersionTransforms", CaptainAppVersionTransforms)
  .config(captainAppVersionUrls);

export default captainAppVersionModule;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersion/captainAppVersion.module.js